import React, { Component } from 'react';
import Mentor from './Mentor/Mentor';
import './Mentors.css';
import MentorImg from './mentor.png';
import Fade from 'react-reveal/Fade';

class Mentors extends Component {
    state = {
        persons: [
            { className: "class1", name: "Name", position: "Co-Founder" },
            { className: "class2", name: "Name", position: "Mentor" },
            { className: "class3", name: "Name", position: "Mentor" }
        ]
    }

    render = () => {
        return (
            <div className="mentors">
                <div className="container-fluid main-div">
                    <h3 className="main">
                        <Fade delay={300}>
                            <span className="con1">Co-Founder &nbsp;</span>
                            <span className="con2">&</span>
                            <span className="con3">&nbsp; Mentors </span>
                        </Fade>
                    </h3>
                    <br /> 
                    <div className="cards">
                        <div className="row">
                            <div className="col">
                                <Mentor className={this.state.persons[0].className} name={this.state.persons[0].name} position={this.state.persons[0].position} src={MentorImg} />
                            </div>
                            <div className="col">
                                <Mentor className={this.state.persons[1].className} name={this.state.persons[1].name} position={this.state.persons[1].position} src={MentorImg} />
                            </div>
                            <div className="col">
                                <Mentor className={this.state.persons[2].className} name={this.state.persons[2].name} position={this.state.persons[2].position} src={MentorImg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Mentors;